import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          HomeTitle  , ResponsiveYouTubeIframe       } from '../../Components/UI/UI'

import {  newVideos } from "../../Data/Data";
import { getWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./Testimonials.css"

class Testimonials extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  


  render(){
    

     // get all posts 
    const  posts = [ ...newVideos ] ;
    console.log('posts:', posts);

    // get video posts 
    const nonVidPosts = posts.filter((o , i )=>{
      return ( o.isVid === true  || o.forVidPage === true) && o.isDouble === false;
    })

    console.log('nonVidPosts:', nonVidPosts);


    const concertSHtml = posts.map( (o,i) => {
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
       const url = "/Posts/Videos/" + o.ctg  + '/' + o.id;
 
        return <VideoSliderItem  
                  key={i}
                  title={o.title}
                  desc={""}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass}
                 />
    });

    return(
      <div className="inner-page align-center page-ExporeTelAvivAndJerusalem page-testimonials">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
             TESTIMONIALS
            </HomeTitle>
            <ResponsiveYouTubeIframe vidId={'LYa9VPVAJI8'} />
            <div className="live-shows-wrapper">
              {concertSHtml}
             
            </div>
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default Testimonials


// WEBPACK FOOTER //
// ./src/Pages/Testimonials/Testimonials.js